import RelationToOneField from '@/shared/fields/relation-to-one-field';
import ApiService from '@/shared/services/api.service';

export class ApplicationTypeField {
    static relationToOne(name, label, rules, filterParams, children, options) {
        return new RelationToOneField(
            name,
            label,
            () => {
                return new Promise(async (resolve) => {
                    let params = {
                        query: 'is_auto eq false and status eq active',
                        limit: 100,
                    }

                    ApiService.query('/application-types', { params }).then(({ data }) => {
                        resolve(data);
                    });
                });
            },
            (record) => {
                if (!record) {
                    return '';
                }

                return {
                    value: record.id,
                    text: record.name,
                };
            },
            rules,
            filterParams,
            children,
            options
        );
    }
}
